export default __webpack_public_path__ + "static/media/gallery-h-1.1a93c0f9.png";